import {
  FormControl,
  MenuItem,
  Select,
  Box,
  Chip,
  type SxProps
} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { ErrorDisplay } from 'ContextProviders/ErrorProvider'
import { type SelectOption } from 'Components/SelectWithLabel'
import { LabelWithToolTip } from 'Components/Label/Index'

interface Props {
  options: Array<SelectOption<string>>
  values: string[] | undefined
  onChange: (event: string[]) => void
  name: string
  label: string
  toolTipText?: string
  labelSx?: SxProps
}

export function ChipSelect (props: Props): JSX.Element {
  const { values, name, options, label, onChange } = props
  const currentValue = values
  return (
    <Box>
      <ErrorDisplay fieldName={props.name} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <LabelWithToolTip labelText={label} sx={props.labelSx} toolTipText={props.toolTipText} />
      </Box>
      <FormControl
        variant="filled"
        sx={{ pt: 0, pb: 2, width: '100%' }}
      >
        <Select
          data-testid={name}
          labelId={name}
          id={`${name}-select`}
          name={name}
          value={currentValue}
          onChange={(e) => { onChange(e.target.value as string[]) }}
          variant="outlined"
          IconComponent={KeyboardArrowDownIcon}
          multiple
          fullWidth
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                width: 250
              }
            }
          }}
          renderValue={(selected: string[]) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {
              selected.map((value) => {
                const displayValue = options.find(o => o.id.toString() === value)?.name ?? value
                return <Chip key={value} label={displayValue}
                  onMouseDown={(event) => {
                    event.stopPropagation()
                  }}
                  onDelete={(e) => {
                    const newList = selected.filter(s => s !== value)
                    props.onChange(newList)
                  }}
                />
              }
              )}
            </Box>
          )}

        >
          {options?.map((opt) => (
            <MenuItem key={opt.id.toString()} value={opt.id.toString()} role="option" data-testid={'select-item-' + opt.id.toString()}>
              {opt.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
